module.exports = __webpack_public_path__ + "img/logo-horizontal-white.62c62fce.svg";